module.exports = __webpack_public_path__ + "kn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/kn.svg
// module id = 896
// module chunks = 0